import { type RecentColleague } from "@src/appV2/Agents/api/useGetRecentColleagues";

import { type WorkerPublicProfile } from "../hooks/useGetWorkerPublicProfile";
import { useIsWorkWithFriendsV2Enabled } from "../hooks/useIsWorkWithFriendsV2Enabled";
import { WorkTogetherStack } from "./WorkTogetherStack";

interface WorkTogetherStackContainerProps {
  workers: WorkerPublicProfile[];
  friendsMap?: Map<string, WorkerPublicProfile>;
  recentColleaguesMap?: Map<string, RecentColleague>;
}

export function WorkTogetherStackContainer(props: WorkTogetherStackContainerProps) {
  const isWorkWithFriendsV2Enabled = useIsWorkWithFriendsV2Enabled();

  if (!isWorkWithFriendsV2Enabled) {
    return null;
  }

  return <WorkTogetherStack {...props} />;
}
